"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathJaxPreprocessor = void 0;
const replace_align_with_aligned_1 = require("./replace-align-with-aligned");
const escape_text_symbols_1 = require("./escape-text-symbols");
const fix_nested_cancel_commands_1 = require("./fix-nested-cancel-commands");
const fix_stackrel_braces_1 = require("./fix-stackrel-braces");
const fix_overset_braces_1 = require("./fix-overset-braces");
const fix_dfrac_braces_1 = require("./fix-dfrac-braces");
const fix_hat_braces_1 = require("./fix-hat-braces");
const fix_sqrt_braces_1 = require("./fix-sqrt-braces");
const fix_bold_1 = require("./fix-bold");
const fix_colors_1 = require("./fix-colors");
const remove_comments_in_color_blocks_1 = require("./remove-comments-in-color-blocks");
const fix_commands_with_missing_arg_1 = require("./fix-commands-with-missing-arg");
const fix_text_underscores_1 = require("./fix-text-underscores");
const fix_text_1 = require("./fix-text");
const fix_text_in_text_1 = require("./fix-text-in-text");
const fix_widehat_1 = require("./fix-widehat");
const fix_vec_braces_1 = require("./fix-vec-braces");
const fix_underline_1 = require("./fix-underline");
const fix_fbox_1 = require("./fix-fbox");
const fix_overbrace_1 = require("./fix-overbrace");
const fix_linebreaks_1 = require("./fix-linebreaks");
const escape_unsupported_unicode_1 = require("./escape-unsupported-unicode");
const fix_unicode_text_layout_1 = require("./fix-unicode-text-layout");
const fix_overline_1 = require("./fix-overline");
const fix_xrightarrow_1 = require("./fix-xrightarrow");
const fix_space_blocks_1 = require("./fix-space-blocks");
const fix_ellipsis_1 = require("./fix-ellipsis");
const fix_hphantom_ellipsis_1 = require("./fix-hphantom-ellipsis");
const fix_text_caret_1 = require("./fix-text-caret");
const fix_comma_in_dimension_1 = require("./fix-comma-in-dimension");
const fix_underset_1 = require("./fix-underset");
const fix_red_hearts_1 = require("./fix-red-hearts");
const fix_oneoffs_1 = require("./fix-oneoffs");
const fix_text_it_1 = require("./fix-text-it");
const fix_empty_sqrt_1 = require("./fix-empty-sqrt");
const fix_big_brackets_1 = require("./fix-big-brackets");
const escape_square_bracket_after_begin_1 = require("./escape-square-bracket-after-begin");
const fix_th_1 = require("./fix-th");
const fix_boxed_in_text_1 = require("./fix-boxed-in-text");
const fix_dots_in_text_1 = require("./fix-dots-in-text");
const fix_double_backslash_in_color_1 = require("./fix-double-backslash-in-color");
const fix_text_in_colorbox_1 = require("./fix-text-in-colorbox");
const fix_substack_colors_1 = require("./fix-substack-colors");
const fix_unicode_outside_text_1 = require("./fix-unicode-outside-text");
const fix_aligned_phantom_1 = require("./fix-aligned-phantom");
const fix_sqrt_spacing_1 = require("./fix-sqrt-spacing");
// Copied from https://github.com/Khan/mu-lambda/blob/master/src/index.js
// Copied rather than imported to decouple this code from webapp's dependencies,
// in preparation for duplicating this code in the mobile repo.
const pipe = (...farr) => (x) => farr.reduce((v, f) => f(v), x);
class MathJaxPreprocessor {
    constructor({ shouldFixUnicodeLayout }) {
        this.preprocessTex = (tex) => {
            const normalizedTex = this.fixNonstandardSyntax(tex);
            return {
                normalizedTex,
                normalizedTexWithMathjaxWorkarounds: this.workAroundMathJaxDeficiencies(normalizedTex),
            };
        };
        this.fixNonstandardSyntax = pipe(escape_text_symbols_1.escapeTextSymbols, fix_nested_cancel_commands_1.fixNestedCancelCommands, fix_stackrel_braces_1.fixStackrelBraces, fix_overset_braces_1.fixOversetBraces, fix_overbrace_1.fixOverbraces, fix_dfrac_braces_1.fixDfracBraces, fix_hat_braces_1.fixHatBraces, fix_sqrt_braces_1.fixSqrtBraces, fix_bold_1.fixBold, fix_text_in_text_1.fixTextInText, fix_fbox_1.fixFbox, fix_text_1.fixText, fix_unicode_outside_text_1.fixUnicodeOutsideText, fix_colors_1.fixColors, fix_commands_with_missing_arg_1.fixCommandsWithMissingArg, fix_widehat_1.fixWidehat, fix_vec_braces_1.fixVecBraces, fix_overline_1.fixOverline, fix_underline_1.fixUnderline, fix_text_underscores_1.fixTextUnderscores, fix_space_blocks_1.fixSpaceBlocks, fix_xrightarrow_1.fixXrightarrow, fix_ellipsis_1.fixEllipsis, fix_hphantom_ellipsis_1.fixHPhantomEllipsis, fix_text_caret_1.fixTextCaret, fix_comma_in_dimension_1.fixCommaInDimension, fix_underset_1.fixUnderset, fix_empty_sqrt_1.fixEmptySqrt, escape_square_bracket_after_begin_1.escapeSquareBracketAfterBegin, fix_red_hearts_1.fixRedHearts, fix_oneoffs_1.fixOneoffs, fix_text_it_1.fixTextIt, fix_big_brackets_1.fixBigBrackets, fix_th_1.fixTh, fix_boxed_in_text_1.fixBoxedInText, fix_dots_in_text_1.fixDotsInText, fix_double_backslash_in_color_1.fixDoubleBackslashInColor, fix_text_in_colorbox_1.fixTextInColorbox, fix_substack_colors_1.fixSubstackColors, fix_aligned_phantom_1.fixAlignedPhantom);
        this.workAroundMathJaxDeficiencies = pipe(replace_align_with_aligned_1.replaceAlignWithAligned, fix_linebreaks_1.fixLinebreaks, fix_sqrt_spacing_1.fixSqrtSpacing, (tex) => this.shouldFixUnicodeLayout ? (0, fix_unicode_text_layout_1.fixUnicodeTextLayout)(tex) : tex, escape_unsupported_unicode_1.escapeUnsupportedUnicode, remove_comments_in_color_blocks_1.removeCommentsInColorBlocks);
        this.shouldFixUnicodeLayout = shouldFixUnicodeLayout;
    }
}
exports.MathJaxPreprocessor = MathJaxPreprocessor;
